import { types } from 'mobx-state-tree';

const OrderTotalClass = {
  TOTAL: 'TOTAL',
  TAX_FREE_TOTAL: 'TAX_FREE_TOTAL',
  TAX_TOTAL: 'TAX_TOTAL',
  EXTRA_TOTAL: 'EXTRA_TOTAL',
  PRODUCTS_TOTAL: 'PRODUCTS_TOTAL',
  SHIPPING_TOTAL: 'SHIPPING_TOTAL',
  LOW_ORDER_FEE_TOTAL: 'LOW_ORDER_FEE_TOTAL',
  PAYMENT_TOTAL: 'PAYMENT_TOTAL',
  CAMPAIGN_CODE_DISCOUNT: 'CAMPAIGN_CODE_DISCOUNT',
};

export default OrderTotalClass;

export const OrderTotalType = types.enumeration(
  'OrderTotalClass',
  Object.values(OrderTotalClass)
);
